import { AssignedPromotions } from '@/components/blocks/PromotionCard/parts/AssignedPromotions';
import { PromotionIcon } from '@/components/blocks/PromotionCard/parts/PromotionIcon';
import { useDefaultStore } from '@/data/Content/DefaultStore';
import {
	filterAndOrderPromoIcons,
	findPromoIconsFromAttributeByStoreAndMarketId,
	useRibbonURLs,
} from '@/data/Content/PromoIcons';
import { usePromoMessage } from '@/data/Content/PromoMessage';
import { isB2BStore, useSettings } from '@/data/Settings';
import { ResponseProductAttribute } from '@/data/types/Product';
import { getStoreDataByPhysicalStoreId } from '@/data/utils/commonIntegrationUtils';
import { Grid } from '@mui/material';
import { FC } from 'react';

type PromotionCardType = {
	id: string;
	attributes?: ResponseProductAttribute[];
	partNumber?: string;
	showDescription?: boolean;
};

export const PromotionCard: FC<PromotionCardType> = ({
	id: catentryId,
	attributes,
	partNumber,
	showDescription = false,
}) => {
	const { settings } = useSettings();
	const isB2B = isB2BStore(settings);
	const { physicalStoreId } = useDefaultStore();
	const { marketId } = getStoreDataByPhysicalStoreId(physicalStoreId);

	const promoIconsAttrs = findPromoIconsFromAttributeByStoreAndMarketId(
		attributes || [],
		isB2B,
		marketId || ''
	);
	const ribbonURLs = useRibbonURLs();
	const filteredIcons = filterAndOrderPromoIcons(promoIconsAttrs);

	const { data: promoMessage } = usePromoMessage(catentryId);

	if (filteredIcons.length < 1) return null;

	if (showDescription && catentryId) {
		return (
			<AssignedPromotions
				promoData={promoMessage}
				orderRibbons={filteredIcons}
				partNumber={partNumber}
			/>
		);
	}

	return (
		<Grid container spacing={2} alignItems="flex-start">
			{filteredIcons.map(
				(attr) =>
					attr &&
					attr.identifier &&
					ribbonURLs[attr.identifier] && (
						<PromotionIcon
							key={attr.identifier}
							iconURL={ribbonURLs[attr.identifier]}
							title={attr.identifier}
						/>
					)
			)}
		</Grid>
	);
};
